






























































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColumnApi,
} from 'ag-grid-community';

import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchMantenedorCoordinador } from './fetchMantenedorCoordinador';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

import ModalViewCoordinador from './ModalViwCoordinador.vue';
import ModalVerHistorial from './ModalVerHistorial.vue';
import { getUserId } from './helpers/getUserId';
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
    'app-confirmacion': Confirmation,
    ModalViewCoordinador,
    ModalVerHistorial,
  },
})
export default class MantenedorCoordinadorBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.coordinador;
  loadingService = new LoadingService();
  columnApi: any = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  ordesList: any[] = [];
  coorid: any = '';
  usuarioid_modifica: any = '';
  data: any = {};
  filtrobusquedagrilla: string = '';
  dialogEliminar: boolean = false;
  showModal: boolean = false;
  anulado: boolean = false;
  tipo: any[] = [];

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEdit);
    actionsEvent.onVerHistorico(this.handleHistorialClick);
    actionsEvent.onEliminar(this.handleDelete);
  }
  cooridSelected: number;
  coorSelected: String;
  coorSelectedApellido: String;
  mostrarModalHistorial: boolean = false;
  handleHistorialClick(params: ICellRendererParams) {
    this.cooridSelected = params.data.coorid;
    this.coorSelected = params.data.coorname;
    this.coorSelectedApellido = params.data.coorapellido;
    this.mostrarModalHistorial = true;
  }

  async recargarGrilla() {
    this.ordesList = await this.getCoordinadores();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.data = {};
  }

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        'Nombre Coordinador': e.coorname,
        'Apellido Coordinador': e.coorapellido,
        'Fecha De Registro': moment(e.coorfecha_alta).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        Estado: e.coorbaja,
        Tipo: e.configdescripcion,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Coordinadores');
    writeFileXLSX(wb, 'Coordinadores.xlsx');
    this.$snotify.success('Excel Exportado con éxito', 3000);
  }

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionEditar, this.accionEliminar];

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Nombre Coordinador',
        field: 'coorname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
      },
      {
        headerName: 'Apellido Coordinador',
        field: 'coorapellido',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
      },
      {
        headerName: 'Fecha De Registro',
        field: 'coorfecha_alta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
        cellRenderer: (param: any) =>
          param.data.coorfecha_alta.substring(0, 19),
      },
      {
        headerName: 'Estado',
        field: 'coorbaja',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
        cellRenderer: (params: any) => {
          return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
            params.data.coorbaja == 'ACTIVO'
              ? 'rgb(42, 255, 78)'
              : 'rgb(255, 58, 58)'
          } " ></i>
          <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${
            params.data.coorbaja
          }</a>`;
        },
      },
      {
        headerName: 'Tipo',
        field: 'configdescripcion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 300,
      },
    ],
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 50,
    onGridReady: this.handleGridReady,
  };

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getCoordinadores();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
  handleSearch() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleAdd(event: any) {
    this.showViewModal(event, true);
  }

  handleEdit(event: any) {
    this.showViewModal(event);
  }

  showViewModal(params: ICellRendererParams, addaction: boolean = false) {
    if (addaction) {
      this.data = {};
      this.anulado = false;
    } else {
      this.data = params.data;
      this.anulado = params.data.coorbaja == 'INACTIVO';
    }
    /*else if (params.data.coorbaja != 'ACTIVO') {
    this.data = params.data;
  } else {
    this.data = params.data;
  } */

    this.showModal = true;
  }

  handleClosedModal() {
    this.showModal = false;
    this.mostrarModalHistorial = false;
    this.recargarGrilla();
  }

  handleDelete(event: any) {
    this.data = event.data;
    this.dialogEliminar = true;
  }

  handleDeleteCoor(event: any) {
    this.dialogEliminar = false;
    if (event) {
      this.deletecoordinador(this.data);
    }
  }

  async getCoordinadores() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorCoordinador(
      { ClienteDefecto: JSON.parse(localStorage.getItem('clienteDefecto')) },
      'api_coordinadores/get_coordinadores'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          return [];
        }
        self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getTipoParametro() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorCoordinador({}, 'api_coordinadores/get_tipoParametro')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          return [];
        }
        self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async deletecoordinador(params: any) {
    const { coorid, coorname, coorapellido } = params;
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorCoordinador(
      {
        coorid: Number(coorid),
        coorname: coorname,
        coorapellido: coorapellido,
        usuarioid_modifica: getUserId(),
        usuariorut_modifica: localStorage.getItem('clienteDefecto'),
      },
      'api_coordinadores/delete_coordinador'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.ordesList = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(async () => {
        this.loadingService.hideLoading();
        this.recargarGrilla();
      });
  }

  async mounted() {
    this.tipo = await this.getTipoParametro();
  }
}
